module.exports = __webpack_public_path__ + "static/media/mastercardLight.457cb7ab.svg";